// extracted by mini-css-extract-plugin
module.exports = {"cont":"FooterWeb_cont__gSDvV","textBox":"FooterWeb_textBox__3ssJ-"};